import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { PaginationChangeEvent } from './pagination.model';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent {
  @Input() totalCount = 0;
  @Input() pageSize = 20;
  @Input() offset = 0;
  @Input() pageSizeOptions: number[] = [10, 20, 50];
  @Input() disabled = false;
  @Input() hidden = false;
  @Input() showFirstLastButtons = true;
  @Input() ariaLabel = 'Select page';

  @Output() pageChange = new EventEmitter<PaginationChangeEvent>();

  get safeTotalCount(): number {
    return Number.isFinite(this.totalCount) ? Math.max(0, this.totalCount) : 0;
  }

  get safePageSize(): number {
    return Number.isFinite(this.pageSize) && this.pageSize > 0 ? this.pageSize : 20;
  }

  get safeOffset(): number {
    return Number.isFinite(this.offset) ? Math.max(0, this.offset) : 0;
  }

  get pageIndex(): number {
    const size = this.safePageSize;
    const rawIndex = Math.floor(this.safeOffset / size);
    const maxIndex = Math.max(0, Math.ceil(this.safeTotalCount / size) - 1);
    return Math.min(rawIndex, maxIndex);
  }

  onPage(event: PageEvent): void {
    const size = Number.isFinite(event.pageSize) && event.pageSize > 0 ? event.pageSize : this.safePageSize;
    const index = Number.isFinite(event.pageIndex) ? Math.max(0, event.pageIndex) : 0;
    this.pageChange.emit({
      offset: index * size,
      limit: size,
      pageIndex: index,
      pageSize: size,
    });
  }
}
